export default __webpack_public_path__ + "static/Live-Video_Kaspersky2013-3584ab772f2fc32d9323702978b29eab.webp";